module.exports = __webpack_public_path__ + "static/media/Yoimiya.593e6a6d.png";